function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import HerramientaDibujoBase from './herramienta-dibujo-base'; // const hexToRgbA = (hex, a) => {
//     var c;
//     if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
//         c= hex.substring(1).split('');
//         if(c.length === 3){
//             c= [c[0], c[0], c[1], c[1], c[2], c[2]];
//         }
//         c= '0x'+c.join('');
//         return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',' + a + ')';
//     }
//     throw new Error('Bad Hex');
// }

var Lapiz = function (_HerramientaDibujoBas) {
  _inherits(Lapiz, _HerramientaDibujoBas);

  function Lapiz(color, grosor) {
    _classCallCheck(this, Lapiz);

    var _this = _possibleConstructorReturn(this, _HerramientaDibujoBas.call(this, 'Lapiz', color, grosor));

    _this.herramientaDown = function (ctx, x, y) {
      ctx.globalCompositeOperation = 'source-over';
      ctx.strokeStyle = _this.color; // 'rgb(20, 20, 20)';

      ctx.lineWidth = _this.grosor; // 5

      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      ctx.moveTo(x, y);

      _this.puntos.push({
        x: x,
        y: y
      });
    };

    _this.herramientaMove = function (ctx, x, y) {
      ctx.lineTo(x, y);
      ctx.stroke();

      _this.puntos.push({
        x: x,
        y: y
      });
    };

    _this.herramientaUp = function (ctx, x, y) {
      if (_this.puntos.length === 0) {
        return;
      }

      ctx.globalCompositeOperation = 'source-over';
      ctx.strokeStyle = _this.color; // 'rgb(20, 20, 20)';

      ctx.lineWidth = _this.grosor; // 5

      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      ctx.moveTo(_this.puntos[0].x, _this.puntos[0].y);

      _this.puntos.forEach(function (_ref) {
        var x = _ref.x,
            y = _ref.y;
        return ctx.lineTo(x, y);
      });

      ctx.stroke();
      _this.puntos = [];
    };

    _this.puntos = [];
    return _this;
  }

  return Lapiz;
}(HerramientaDibujoBase);

export default Lapiz;